<!-- Banner superior -->
<don-campaign-selected-banner [campaign]="selectedCampaign$ | async">
</don-campaign-selected-banner>

<!-- Contenido -->
<div class="donation-shell">
  <div class="donation-layout" [class.donation-layout--campaigns]="showCampaignsCol$ | async">

    <!-- Left: Campaigns -->
    <aside *ngIf="showCampaignsCol$ | async" class="donation-panel donation-panel--campaigns">

      <h5 class="donation-panel__title">
        {{ 'CAMPAIGN.Campaigns' | translate }}
      </h5>

      <don-campaign class="donation-campaigns-list" [campaigns]="campaigns$ | async" [selectedId]="selectedId$ | async"
        (select)="onSelectCampaign($event)">
      </don-campaign>
    </aside>

    <!-- Workspace: información de campaña a la izquierda y donantes recientes a la derecha -->
    <section class="donation-workspace">

      <div class="donation-action-row">

        <!-- Información principal de la campaña -->
        <main class="donation-main">
          <don-selected-card class="donation-selected-intro" section="intro" [campaign]="selectedCampaign$ | async"
            [donorsCount]="(donorsCount$ | async) || 0">
          </don-selected-card>

          <don-selected-card class="donation-selected-progress" section="progress"
            [campaign]="selectedCampaign$ | async">
          </don-selected-card>

          <section class="donation-calculator">
            <h6 class="donation-calculator__title">
              <span class="donation-calculator__check" aria-hidden="true">✓</span>
              {{ 'CAMPAIGN.ChooseAmount' | translate }}
            </h6>

            <don-price-form class="donation-price-form" [price]="draftPrice$ | async"
              [canAcceptRecurring]="(canAcceptRecurring$ | async) ?? false" (submitted)="onSubmit($event)">
            </don-price-form>
          </section>
        </main>

        <!-- Recent donors -->
        <aside class="donation-panel donation-panel--recent">
          <don-recent-donors class="donation-recent-donors">
          </don-recent-donors>
        </aside>

      </div>
    </section>

  </div>
</div>

<!-- Footer -->
<div class="container-fluid px-0 donation-footer-wrap">
  <don-footer [org]="org"></don-footer>
</div>